
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faFileWord } from "@fortawesome/free-solid-svg-icons/faFileWord";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons/faWhatsapp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent, DialogProps } from "@mui/material";
import { PermissoesImpressao, RespostaModalImprimir } from "app/types/modalImprimir/RespostaModalImprimir";
import React, { memo, useMemo } from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { SenhaMarkup } from "app/components/markup/senha-markup/SenhaMarkup";
import { SolicitarSenhaContainer } from "app/components/senha/SolicitarSenhaContainer";
import { PermissaoSenhaModalImprimirProps } from "./modalImprimirContainer";
import { PaperArrastavel } from "../../../dialog-arrastavel/PaperArrastavel";

const estiloModalImprimir =
    require("./modal-imprimir.module.scss").default;


export type ModalImprimirProps = {
    dados: RespostaModalImprimir[];
    nomeArquivoWord: string;
    onClose: () => void;
    onImprimir: (urlModeloTemplate: string) => void;
    linkWord: (urlModeloTemplate: string) => string;
    onEmail: (dado: RespostaModalImprimir) => void;
    onWhatsapp: (dado: RespostaModalImprimir) => void;
    permitidoWord: boolean
    permitidoEmail: boolean
    // senhaSolicitar?: string //450413
    // senhaSolicitarDica?: string //450413
    // senhaTextoAdicional?: string //450413
    permissaoSenhaModalImprimir?: PermissaoSenhaModalImprimirProps // 450413
    pedirSenha?: boolean //450413
    onSenhaValidada?: (senhaValida: boolean, senha?: string) => void

}

export const ModalImprimir = memo((props: ModalImprimirProps) => {

    const divTitulo = useMemo(() => (
        <div className={estiloModalImprimir.titulo} data-arrastar-dialog
            id="modalImprimir_Titulo"
        >
            <h4 style={{ fontWeight: 700 }}
                id="modalImprimir_Titulo_Texto"
            >
                {props.pedirSenha
                    ? "Autorização de Impressão"
                    : "Escolha um Modelo para Imprimir"
                }
            </h4>
            <div id="modalImprimir_Titulo_Acoes">
                <a onClick={props.onClose}
                    id="modalImprimir_BotaoFechar"
                    title="Fechar"
                >
                    <FontAwesomeIcon
                        icon={faTimes}
                        id="modalImprimir_iconeFechar"
                        cursor={"pointer"}
                        className={estiloModalImprimir.exit}
                        opacity={0.2}
                    />
                </a>
            </div>
        </div>
    ), [props.pedirSenha, props.onClose]);

    const solicitarSenhaContainer = useMemo(() => (
        props.pedirSenha // 450413
            ? <section
                id="modalImprimir_corpoModal_SolicitarSenha"
                style={{ padding: "0 15px" }}
            >
                <SolicitarSenhaContainer
                    onRemover={() => { }}
                    onVoltar={() => { }}
                    passos={null}
                    exibirBotaoVoltar={false}
                    onSenhaValidada={props.onSenhaValidada}
                    dicaPermissao={props.permissaoSenhaModalImprimir?.senhaSolicitarDica}
                    permissao={props.permissaoSenhaModalImprimir?.senhaSolicitar}
                    textoAdicional={props.permissaoSenhaModalImprimir?.senhaTextoAdicional}
                />
            </section>
            : null
    ), [props.pedirSenha, props.onSenhaValidada, props.permissaoSenhaModalImprimir]);

    const corpoModal = useMemo(() => (
        props.pedirSenha // 450413
            ? null
            : <div className={estiloModalImprimir.modalBody}
                id="modalImprimir_corpoModal"
            >
                <table className={estiloModalImprimir.tabela}
                    id="modalImprimir_corpoModal_Tabela"
                >
                    <thead
                        id="modalImprimir_corpoModal_CabecalhoTabela"
                    >
                        <tr id="modalImprimir_corpoModal_CabecalhoTabela_Linha">
                            <th id="modalImprimir_corpoModal_CabecalhoTabela_Modelo">Modelo</th>
                            <th id="modalImprimir_corpoModal_CabecalhoTabela_Acoes"></th>
                        </tr >
                    </thead>
                    {/* Um <tbody> só, com uma <tr> por modelo. Antes cada modelo abria um <tbody>
                        próprio, todos com o MESMO id — id repetido é inválido e faz
                        document.getElementById devolver sempre a primeira linha. Os ids das ações
                        também levam o índice pelo mesmo motivo. */}
                    <tbody
                        id="modalImprimir_corpoModal_CorpoTabela"
                    >
                        {props?.dados?.map((dado, index) => (
                            <tr className={estiloModalImprimir.linha}
                                key={dado.Url ?? index}
                                id={`modalImprimir_corpoModal_Linha_${index}`}
                            >
                                <td id={`modalImprimir_corpoModal_Descricao_${index}`}>
                                    <a onClick={() => props.onImprimir(dado.Url)}
                                        id={`modalImprimir_corpoModal_LinkImprimir_${index}`}
                                    >{dado.Descricao}</a>
                                </td>
                                <td className={estiloModalImprimir.icons}
                                    id={`modalImprimir_corpoModal_Acoes_${index}`}
                                >

                                    <FontAwesomeIcon
                                        icon={faPrint}
                                        id={`modalImprimir_iconeImprimir_${index}`}
                                        cursor={"pointer"}
                                        className={estiloModalImprimir.icone}
                                        onClick={() => props.onImprimir(dado.Url)}
                                        title="Imprimir"
                                    />

                                    {props.permitidoWord && <a className={estiloModalImprimir.icone} href={props.linkWord(dado.Url)}
                                        download={props?.nomeArquivoWord}
                                        id={`modalImprimir_linkWord_${index}`}
                                        title="Baixar em Word"
                                    >
                                        <FontAwesomeIcon
                                            icon={faFileWord}
                                            id={`modalImprimir_iconeWord_${index}`}
                                            cursor={"pointer"}
                                        />
                                    </a>}

                                    {props.permitidoEmail && <FontAwesomeIcon
                                        icon={faEnvelope}
                                        id={`modalImprimir_iconeEmail_${index}`}
                                        cursor={"pointer"}
                                        className={estiloModalImprimir.icone}
                                        onClick={() => props.onEmail(dado)}
                                        title="Enviar por e-mail"
                                    />}

                                    {props.permitidoEmail && <FontAwesomeIcon
                                        icon={faWhatsapp as IconProp}
                                        cursor={"pointer"}
                                        id={`modalImprimir_iconeWhatsApp_${index}`}
                                        className={estiloModalImprimir.iconeWhatsapp}
                                        onClick={() => props.onWhatsapp(dado)}
                                        title="Enviar por WhatsApp"
                                    />}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
    ), [
        props.pedirSenha,
        props.dados,
        props.permitidoWord,
        props.permitidoEmail,
        props.nomeArquivoWord,
        props.onImprimir,
        props.onEmail,
        props.onWhatsapp,
        props.linkWord
    ]);

    return (
        <Dialog
            open={true}
            onClose={props.onClose}
            scroll={"paper"}
            fullWidth
            maxWidth={"md"}
            className={estiloModalImprimir.dialogModalImprimir}
            id="modalImprimir"
            PaperComponent={PaperArrastavel}
        >
            {divTitulo}
            <DialogContent
                dividers
                style={{ padding: "0px" }}
                id="modalImprimir_DialogContent"
            >

                {solicitarSenhaContainer}

                {corpoModal}


                <DialogActions style={{ padding: "15px" }}
                    id="modalImprimir_DialogActions"
                >
                    <button
                        className={estiloModalImprimir.botao}
                        id="modalImprimir_Fechar"
                        onClick={props.onClose}
                        style={{
                            margin: "0 3px 0 0",
                            padding: "7px 1em",
                        }}
                    >
                        Fechar
                    </button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    )
})
